import { fromJS } from 'immutable';
import { normalizeItems } from '@Utils';
import { saveRelativeContextType, clearRelativeContextType } from './RelativeContextConstants';

export const initialState = fromJS({});

// eslint-disable-next-line default-param-last
export default function relativeContextReducer(state = initialState, action) {
  switch (action.type) {
    case saveRelativeContextType: {
      const { hitSetKey, relativeContexts } = action.payload;
      const { items, ids } = normalizeItems(relativeContexts);

      return state.set(hitSetKey, fromJS({ items, ids }));
    }

    case clearRelativeContextType: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
